import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class StandardOptionI18nCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	// 基本設定
	public base = createFeatureIslandCategoryStore({
		title: "オプション名・画像",
		description: "",
		isBasicSetup: true,
	});

	public subOption = createFeatureIslandCategoryStore({
		title: "サブオプション",
		description: "",
		isBasicSetup: true,
	});

	// ここから下は 「追加設定」isBasicSetup: false

	public categoryStoreArray = [this.base, this.subOption];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const standardOptionI18nCategoriesAndManagerStore = new StandardOptionI18nCategoriesAndManagerStore();
